import { config } from 'env_def';
import { AllStatType, } from '@/api/system/performance';
import { api } from '@/api/api';
import { apis, getPageName, inWindow, isElectron } from '@/config';
import { platform } from '@/api/util/platform';
import { getOs } from '../../../utils/confOs';
const forElectron = config('build_for') === 'electron';
const osType = getOs();
const _platform = forElectron ? osType : 'web-' + platform.os;
const inEdm = process.env.BUILD_ISEDM;
const logItem = ({ statKey, statSubKey, params }) => ({
    start: Date.now(),
    log: [],
    end: 0,
    valueType: 1,
    recording: true,
    statKey,
    statSubKey,
    params,
    type: 'timer',
    dirty: false,
    value: 0,
});
const pointItem = ({ value, statKey, statSubKey, params, valueType }) => ({
    start: Date.now(),
    valueType,
    value,
    statKey,
    statSubKey,
    params,
    type: 'point',
});
const keyMap = {
    heapStatistics: 'pr_heap_mem',
    processMemoryInfo: 'pr_proc_mem',
    CPUUsage: 'pr_cpu_rate',
    webMemory: 'web_memory',
};
class ActionStore {
    constructor() {
        this.pointStore = [];
        this.timerStore = [];
        this.processInfoStore = [];
        this.webMemoryStore = [];
        this.storedStart = {};
        this.illegalStatCount = {
            count: 0,
            lastOccurredTime: Date.now(),
        };
        this.countTaskNumStat = { lstReport: Date.now() };
    }
}
class PerformanceImpl {
    constructor() {
        this.MAX_UPLOAD_SPAN = 3 * 60 * 1000;
        this.MAX_HANDLE_BATCH = 40;
        this.MAX_PROCESS_INFO_STORE_NUM = 3;
        this.MAX_WEB_MEMORY_STORE_NUM = 3;
        this.MAX_SEND_BATCH = 10;
        this.COMMON_TIME_TO_LIVE = 10 * 60 * 1000;
        this.MAX_TIME_SPAN_TO_RECORD = 24 * 3600 * 1000;
        this.switch = false;
        this.processInfoTagArr = ['pr_heap_mem', 'pr_proc_mem', 'pr_cpu_rate'];
        this.keyConfigArr = [
            {
                name: '50-100',
                conditionFn: (val) => val >= 50 && val < 100,
            },
            {
                name: '100-300',
                conditionFn: (val) => val >= 100 && val < 300,
            },
            {
                name: '300-Bigger',
                conditionFn: (val) => val >= 300,
            },
        ];
        this.eagleMonitor = true;
        this.logLeng = 0;
        this.name = apis.performanceImpl;
        this.systemApi = api.getSystemApi();
        this.storeApi = api.getDataStoreApi();
        this.dataTracker = api.requireLogicalApi(apis.dataTrackerApiImp);
        this.loggerTracker = api.requireLogicalApi(apis.loggerApiImpl);
        this.productAuth = api.requireLogicalApi(apis.productAuthApiImpl);
        this.lastUploadTime = Date.now();
        this.lastRecordTime = Date.now();
        this.actionStore = new ActionStore();
        this.longTaskObserving = false;
        this.counterKeys = new Map();
        this.pageName = getPageName();
        this.pid = isElectron() && window.process ? window.process.pid : -1;
        this.contactApi = api.requireLogicalApi(apis.contactApiImpl);
    }
    beforeUpload(flush) {
        if (inWindow()) {
            if (flush || this.logLeng >= this.MAX_HANDLE_BATCH || this.lastRecordTime - this.lastUploadTime > this.MAX_UPLOAD_SPAN) {
                this.uploadLog();
            }
        }
    }
    async time(timeParams) {
        try {
            const { statKey = '', statSubKey = '', params } = timeParams;
            const curTimeItem = logItem({ statKey, statSubKey, params });
            const { key, performanceLog = {}, timerLogs: originTimeLogs } = await this.validateParamGetLogs(timeParams);
            if (!key) {
                return;
            }
            const timeLogger = originTimeLogs || [];
            timeLogger.push(curTimeItem);
            performanceLog[key] = timeLogger;
            this.putPerformanceLog(performanceLog, statKey);
            console.log('[pref] start time logger ', timeLogger);
        }
        catch (e) {
            console.warn(e);
        }
    }
    async timeLog(params) {
        console.log(params);
        throw new Error('not implemented');
    }
    async timeEnd(params, noReport) {
        try {
            const now = Date.now();
            const { timerLogs, performanceLog = {}, perfType, key } = await this.validateParamGetLogs(params, undefined);
            const payload = params.params || {};
            if (!timerLogs || !perfType || !key) {
                return;
            }
            const ttl = perfType.ttl || this.COMMON_TIME_TO_LIVE;
            const timer = timerLogs.pop();
            if (!timer) {
                console.warn('[perf] no start point error record :', params);
                this.recordIllegalEvent();
            }
            else if (timer && timerLogs.length === 0 && !timer.dirty && now - timer.start < ttl) {
                timer.recording = false;
                timer.end = now;
                timer.value = timer.end - timer.start;
                timer.params = Object.assign(Object.assign({}, timer.params), payload);
                if (timer.value < this.MAX_TIME_SPAN_TO_RECORD) {
                    if (!noReport) {
                        this.actionStore.timerStore.push(timer);
                        this.logLeng += 1;
                    }
                }
                console.log('[perf] normal time log:', timer);
            }
            else if (timer) {
                if (now - timer.start < ttl) {
                    timer.recording = false;
                    timer.end = now;
                    timer.value = timer.end - timer.start;
                    timer.dirty = true;
                    timer.params = Object.assign(Object.assign({}, timer.params), payload);
                    if (timer.value < this.MAX_TIME_SPAN_TO_RECORD) {
                        if (!noReport) {
                            this.actionStore.timerStore.push(timer);
                            this.logLeng += 1;
                        }
                    }
                    console.log('[perf] illegal time log:', timer);
                }
                else {
                    console.warn('[perf] timeout point error record :', params);
                    if (!noReport) {
                        this.recordIllegalEvent();
                    }
                }
                if (timerLogs.length > 0) {
                    const newTimeLogs = this.cleanTimeLogger(timerLogs, now, ttl);
                    performanceLog[key] = newTimeLogs;
                }
            }
            this.putPerformanceLog(performanceLog, params.statKey);
            this.lastRecordTime = Date.now();
            if (!noReport) {
                this.beforeUpload(params.flushAndReportImmediate);
            }
        }
        catch (e) {
            console.warn(e);
        }
    }
    cleanTimeLogger(timerLogs, now, ttl) {
        const lastIdx = timerLogs.length - 1;
        let expiredStartIdx = -1;
        for (let idx = lastIdx; idx >= 0; idx -= 1) {
            const item = timerLogs[idx];
            if (now - item.start < ttl) {
                item.dirty = true;
            }
            else {
                expiredStartIdx = idx + 1;
                break;
            }
        }
        if (expiredStartIdx > 0) {
            const newTimeLogs = timerLogs.slice(expiredStartIdx);
            return newTimeLogs;
        }
        return timerLogs;
    }
    async saveLog(param) {
        const addLogs = param || this.buildAddLogs();
        try {
            if (addLogs && addLogs.length > 0) {
                const data = JSON.stringify(addLogs);
                if (isElectron() && window.electronLib) {
                    await window.electronLib.storeManage.set('performanceLog', 'noReportLog', data);
                }
                else {
                    await this.storeApi.put('performanceLog-noReportLog', data, { noneUserRelated: true });
                }
            }
        }
        catch (e) {
            console.warn(e);
        }
    }
    putPerformanceLog(performanceLog, statKey, pgName) {
        if (!performanceLog)
            return;
        if (statKey && AllStatType[statKey] && !AllStatType[statKey].crossWindow) {
            this.actionStore.storedStart = performanceLog;
        }
        else {
            const data = JSON.stringify(performanceLog);
            const inElectron = this.systemApi.isElectron() && window.electronLib;
            if (!inElectron) {
                this.storeApi.put('performanceLog' + (pgName || ''), data).then();
            }
            else {
                window.electronLib.storeManage.set('performanceLog', pgName || 'log', data).then();
            }
        }
        console.log('[perf] put new record for ' + statKey, performanceLog);
    }
    async getPerformanceLog(pgName) {
        const inElectron = this.systemApi.isElectron() && window.electronLib;
        let storePerformanceLog;
        if (!inElectron) {
            const sync = await this.storeApi.get('performanceLog' + (pgName || ''));
            if (sync && sync.suc && sync.data) {
                storePerformanceLog = sync.data;
            }
        }
        else {
            storePerformanceLog = await window.electronLib.storeManage.get('performanceLog', pgName || 'log');
        }
        let performanceLog = {};
        if (storePerformanceLog) {
            performanceLog = JSON.parse(storePerformanceLog);
        }
        return performanceLog;
    }
    async validateParamGetLogs(params, okey, oPerformanceLog) {
        const { key, perfType } = this.testKey(params, okey);
        if (!perfType || !key) {
            return {};
        }
        const performanceLog = oPerformanceLog || (perfType.crossWindow ? await this.getPerformanceLog() : this.actionStore.storedStart) || {};
        const timerLogs = performanceLog[key];
        return {
            timerLogs,
            performanceLog,
            key,
            perfType,
        };
    }
    testKey(params, okey) {
        var _a;
        let key = okey === null || okey === void 0 ? void 0 : okey.toLowerCase();
        if (params && params.statKey) {
            const subkey = ((_a = params.statSubKey) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
            key = params.statKey.toLowerCase() + subkey;
        }
        else {
            return {};
        }
        const retKey = key && /^[$a-z0-9_.-]+$/.test(key) ? key : undefined;
        const perfType = AllStatType[params.statKey];
        if (perfType === undefined) {
            return {};
        }
        return { key: retKey, perfType };
    }
    checkPointParam(param) {
        const { statKey } = param;
        const statsKeyConfig = AllStatType[statKey];
        if (!statsKeyConfig) {
            return false;
        }
        const configCheckFn = statsKeyConfig.checkFn;
        if (typeof configCheckFn === 'function') {
            const result = configCheckFn(param);
            return result;
        }
        return true;
    }
    async point(params) {
        try {
            const allParam = Array.isArray(params) ? params : [params];
            const { item, increasingItem, flush } = allParam.reduce((prev, param) => {
                const { key, perfType } = this.testKey(param);
                if (!key || !this.checkPointParam(param) || !perfType) {
                    return prev;
                }
                const pointType = pointItem(param);
                if (perfType.increasingRecord) {
                    prev.increasingItem.push({ value: pointType, type: perfType, key });
                }
                else {
                    prev.item.push(pointType);
                }
                prev.flush = prev.flush || !!param.flushAndReportImmediate;
                return prev;
            }, { item: [], increasingItem: [], flush: false });
            if (item.length > 0) {
                this.logLeng += item.length;
                this.actionStore.pointStore.push(...item);
                this.lastRecordTime = Date.now();
                this.beforeUpload();
            }
            if (increasingItem.length > 0) {
                const crossWinPerLog = await this.getPerformanceLog();
                const reportItem = increasingItem.map(it => {
                    const { value, type: perfType, key } = it;
                    const performanceLog = perfType.crossWindow ? crossWinPerLog : this.actionStore.storedStart;
                    const timerLogs = performanceLog[key];
                    const prevItem = timerLogs.pop();
                    if (prevItem) {
                        value.value -= prevItem.value;
                    }
                    timerLogs.push(Object.assign({}, value));
                    performanceLog[key] = timerLogs;
                    return value;
                });
                this.logLeng += reportItem.length;
                this.actionStore.pointStore.push(...reportItem);
                if (crossWinPerLog)
                    this.putPerformanceLog(crossWinPerLog);
                this.lastRecordTime = Date.now();
                this.beforeUpload(flush);
            }
        }
        catch (e) {
            console.warn(e);
        }
    }
    async count(params) {
        const handleItems = (crossWinItem, crossPerformanceLog) => {
            crossWinItem.forEach(it => {
                const { value, key } = it;
                this.counterKeys.set(key, value.statKey);
                const logger = crossPerformanceLog[key] || [];
                if (logger.length > 0) {
                    logger[0].value = (logger[0].value || 0) + value.value;
                }
                else {
                    logger.push(value);
                }
                crossPerformanceLog[key] = logger;
            });
        };
        try {
            const allParam = Array.isArray(params) ? params : [params];
            const { item, crossWinItem } = allParam.reduce((prev, param) => {
                const { key, perfType } = this.testKey(param);
                if (!key || !this.checkPointParam(param) || !perfType) {
                    return prev;
                }
                const pointType = pointItem(param);
                const handleItem = { value: pointType, type: perfType, key };
                if (perfType.crossWindow) {
                    prev.crossWinItem.push(handleItem);
                }
                else {
                    prev.item.push(handleItem);
                }
                return prev;
            }, { item: [], crossWinItem: [] });
            if (item.length > 0) {
                const performanceLog = this.actionStore.storedStart;
                handleItems(item, performanceLog);
            }
            if (crossWinItem.length > 0) {
                const crossPerformanceLog = await this.getPerformanceLog(this.pageName + '-' + this.pid);
                handleItems(crossWinItem, crossPerformanceLog);
                if (crossPerformanceLog)
                    this.putPerformanceLog(crossPerformanceLog, undefined, this.pageName + '-' + this.pid);
            }
        }
        catch (e) {
            console.warn(e);
        }
    }
    async getTimerLog(params) {
        const { timerLogs } = await this.validateParamGetLogs(params);
        const timerTypes = this.actionStore.timerStore.filter(it => it.statKey === params.statKey && (!params.statSubKey || params.statSubKey === it.statSubKey));
        const pointTypes = this.actionStore.pointStore.filter(it => it.statKey === params.statKey && (!params.statSubKey || params.statSubKey === it.statSubKey));
        return [...(timerLogs || []), ...timerTypes, ...pointTypes];
    }
    buildAddLogs() {
        const addLogs = [];
        if (this.actionStore.timerStore && this.actionStore.timerStore.length > 0) {
            addLogs.push(...this.actionStore.timerStore);
        }
        if (this.actionStore.pointStore && this.actionStore.pointStore.length > 0) {
            addLogs.push(...this.actionStore.pointStore);
        }
        return addLogs;
    }
    uploadLog() {
        const addLogs = this.buildAddLogs();
        console.log('[perf] upload logs :', addLogs);
        this.doUploadLogs(addLogs);
        this.actionStore.pointStore = [];
        this.actionStore.timerStore = [];
        this.logLeng = 0;
        this.lastUploadTime = Date.now();
    }
    doUploadLogs(addLogs) {
        var _a;
        const userInfo = this.systemApi.getCurrentUser();
        let start = 0;
        const count = addLogs.length;
        const mainAccount = ((_a = this.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        while (start < count) {
            const payload = [];
            addLogs.slice(start, start + this.MAX_SEND_BATCH).forEach(item => {
                var _a, _b, _c;
                const { enableRecordSubAccount = true } = item.params || { enableRecordSubAccount: true };
                const isSubAccount = ((_a = item.params) === null || _a === void 0 ? void 0 : _a._account) && ((_b = item.params) === null || _b === void 0 ? void 0 : _b._account) !== mainAccount;
                if (isSubAccount && !enableRecordSubAccount) {
                    return;
                }
                const subAccountSuffix = isSubAccount ? `_subaccount:${(_c = item.params) === null || _c === void 0 ? void 0 : _c._account}` : '';
                const payloadItem = {
                    statKey: item.statKey + (item.dirty ? '$err' : '') + subAccountSuffix,
                    statSubKey: item.statSubKey || '',
                    ext: item.params || null,
                    valueType: item.valueType,
                    value: item.value,
                    time: item.start,
                };
                payload.push(payloadItem);
            });
            const res = {
                $_lingxi: {
                    _accountId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.accountMd5,
                    _siriusVersion: window.siriusVersion,
                    _platform,
                    _domain: userInfo === null || userInfo === void 0 ? void 0 : userInfo.domain,
                    payload,
                },
            };
            try {
                if (this.eagleMonitor) {
                    this.dataTracker.track(`siruis_desktop_${_platform}_perf`, res);
                }
            }
            catch (e) {
                console.warn(e);
            }
            start += this.MAX_SEND_BATCH;
        }
    }
    init() {
        return this.name;
    }
    afterInit() {
        this.systemApi.getDeviceInfo().then(res => {
            this.deviceConfig = res;
        });
        if (this.systemApi.getCurrentUser()) {
            this.getSwitch().then();
        }
        this.systemApi.intervalEvent({
            eventPeriod: 'extLong',
            seq: 0,
            handler: (ev) => {
                if (ev.seq % 5 === 0 && ev.seq > 3) {
                    if (this.systemApi.isElectron() && window.electronLib) {
                        this.handleProcessInfo().then();
                    }
                    else {
                        this.handleWebMemory();
                    }
                }
                if (ev.seq % 4 === 0 && ev.seq > 3) {
                    this.periodTaskHandle().then();
                }
                if (ev.seq % 10 === 2 && ev.seq > 1) {
                    this.logLongTaskToServer();
                    this.getSwitch().then();
                }
                if (ev.seq % 3 === 0 && ev.seq > 3) {
                    this.handleRemainLog();
                }
                if (ev.seq % 5 === 0 && ev.seq > 3) {
                    this.sendProcessMemoryAndCpuInfos();
                }
            },
        });
        return this.name;
    }
    async getSwitch() {
        if (!process.env.BUILD_ISPREVIEWPAGE) {
            this.switch = (await this.productAuth.getABSwitch('contact_cache'));
        }
    }
    afterLoadFinish() {
        return this.name;
    }
    afterLogin() {
        if (this.systemApi.getCurrentUser()) {
            this.getSwitch().then();
        }
        return this.name;
    }
    beforeLogout() {
        this.actionStore = new ActionStore();
        this.putPerformanceLog({});
        this.putPerformanceLog({}, this.pageName);
        return this.name;
    }
    onFocus() {
        return this.name;
    }
    onPathChange() {
        return this.name;
    }
    handleWebMemory() {
        const { memory } = window.performance;
        const { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize } = memory;
        const repObj = { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize };
        const resObj = {
            webMemory: repObj || {},
        };
        this.actionStore.webMemoryStore.push(resObj);
        if (this.actionStore.webMemoryStore.length > this.MAX_WEB_MEMORY_STORE_NUM) {
            this.handleStore(this.actionStore.webMemoryStore);
            this.actionStore.webMemoryStore = [];
        }
    }
    calcMedian(originArr, m) {
        const arr = originArr.sort((a, b) => a - b);
        const tmp = (arr.length - 1) * m;
        const gw = Math.floor(tmp);
        const xw = tmp.toString().includes('.') ? tmp - gw : 0;
        const res = (1 - xw) * arr[gw] + xw * arr[gw + 1];
        return Number(res.toFixed(2));
    }
    handleStore(storeArr) {
        console.log('handleStorehandleStore', storeArr);
        const arrayObj = {};
        storeArr.forEach((item) => {
            const curInfoObj = item;
            Object.keys(curInfoObj).forEach(key => {
                const curPerfObj = curInfoObj[key];
                Object.keys(curPerfObj).forEach(key1 => {
                    if (!arrayObj[key]) {
                        arrayObj[key] = {};
                    }
                    const curVal = curPerfObj[key1];
                    const isNum = typeof curVal === 'number';
                    if (!arrayObj[key][key1]) {
                        arrayObj[key][key1] = Object.assign({ valArr: [curVal] }, (isNum ? { total: curVal } : {}));
                    }
                    else {
                        arrayObj[key][key1].valArr.push(curVal);
                        if (isNum) {
                            arrayObj[key][key1].total += curVal;
                        }
                    }
                });
            });
        });
        console.log('handleStorehandleStore111', arrayObj);
        const retArr = [];
        Object.keys(arrayObj).forEach(key => {
            const curPerfObj = arrayObj[key];
            Object.keys(curPerfObj).forEach(key1 => {
                var _a;
                const curVal = curPerfObj[key1];
                const { total, valArr } = curVal;
                const statKey = keyMap[key];
                if (!statKey)
                    return;
                const statSubKeySuffix = key1.toLowerCase();
                const { pageName } = this;
                retArr.push({
                    statKey,
                    statSubKey: pageName + '-' + statSubKeySuffix,
                    value: total / ((_a = valArr) === null || _a === void 0 ? void 0 : _a.length),
                    valueType: 2,
                });
                retArr.push({
                    statKey,
                    statSubKey: pageName + '-50-' + statSubKeySuffix,
                    value: this.calcMedian(valArr, 0.5),
                    valueType: 2,
                });
                retArr.push({
                    statKey,
                    statSubKey: pageName + '-90-' + statSubKeySuffix,
                    value: this.calcMedian(valArr, 0.9),
                    valueType: 2,
                });
                retArr.push({
                    statKey,
                    statSubKey: pageName + '-99-' + statSubKeySuffix,
                    value: this.calcMedian(valArr, 0.99),
                    valueType: 2,
                });
            });
        });
        console.log('handleStorehandleStore222', retArr);
        if (retArr.length > 0) {
            this.point(retArr).then();
        }
    }
    async handleProcessInfo() {
        if (window.process) {
            return Promise.all([
                window.process.getHeapStatistics(),
                window.process.getProcessMemoryInfo(),
                window.isBridgeWorker ? window.process.getCPUUsage() : Promise.resolve({}),
            ]).then((res) => {
                console.log('handleProcessInfohandleProcessInfo', res);
                const resObj = {
                    heapStatistics: res[0] || {},
                    processMemoryInfo: res[1] || {},
                    CPUUsage: res[2] || {},
                };
                this.actionStore.processInfoStore.push(resObj);
                if (this.actionStore.processInfoStore.length > this.MAX_PROCESS_INFO_STORE_NUM) {
                    this.handleStore(this.actionStore.processInfoStore);
                    this.actionStore.processInfoStore = [];
                }
            });
        }
    }
    recordIllegalEvent() {
        this.actionStore.illegalStatCount.count += 1;
        const now = Date.now();
        if (now - this.actionStore.illegalStatCount.lastOccurredTime > this.MAX_UPLOAD_SPAN) {
            this.point({
                statKey: 'stat_illegal_count',
                params: { start: this.actionStore.illegalStatCount.lastOccurredTime, end: now },
                value: this.actionStore.illegalStatCount.count,
                valueType: 4,
            }).then();
            this.actionStore.illegalStatCount.lastOccurredTime = now;
            this.actionStore.illegalStatCount.count = 0;
        }
    }
    async periodTaskHandle() {
        const crossPerformanceLog = (await this.getPerformanceLog(this.pageName + '-' + this.pid)) || {};
        const timerStartRecording = this.actionStore.storedStart;
        const items = [];
        this.counterKeys.forEach((statKey, key) => {
            const perfType = AllStatType[statKey];
            const element = perfType.crossWindow ? crossPerformanceLog[key] : timerStartRecording[key];
            if (element && element.length > 0) {
                const elItem = element.pop();
                if (elItem.value !== 0) {
                    items.push(Object.assign({}, elItem));
                    elItem.value = 0;
                    elItem.start = Date.now();
                    element.push(elItem);
                }
            }
        });
        if (items.length > 0) {
            this.point(items).then();
        }
        this.cleanTimeMarkStartRecording(timerStartRecording);
        this.cleanTimeMarkStartRecording(crossPerformanceLog);
        this.putPerformanceLog(crossPerformanceLog);
    }
    cleanTimeMarkStartRecording(timerStartRecording) {
        Object.keys(timerStartRecording).forEach(key => {
            const perfType = AllStatType[key];
            const ttl = (perfType === null || perfType === void 0 ? void 0 : perfType.ttl) || this.COMMON_TIME_TO_LIVE;
            const item = timerStartRecording[key];
            const newLogger = this.cleanTimeLogger(item, Date.now(), ttl);
            timerStartRecording[key] = newLogger;
        });
    }
    getConfigItem(duration) {
        return this.keyConfigArr.find(confItem => {
            try {
                const { conditionFn } = confItem;
                if (conditionFn && typeof conditionFn === 'function') {
                    const result = conditionFn(duration);
                    return result;
                }
                return false;
            }
            catch (ex) {
                console.error(ex);
            }
            return undefined;
        });
    }
    getKeyByDuration() {
        const pageName = getPageName();
        return {
            statKey: 'long_task_record_duration',
            statSubKey: `${pageName}` + (this.switch ? '' : '_B'),
        };
    }
    logLongTaskToServer() {
        if (this.longTaskObserving)
            return;
        const observer = new PerformanceObserver(list => {
            const longTaskEntries = list.getEntries();
            const items = [];
            for (let i = 0; i < longTaskEntries.length; i++) {
                const currLongTaskEntry = longTaskEntries[i];
                console.log('[Long Task]', currLongTaskEntry);
                const { duration, startTime } = currLongTaskEntry;
                const configItem = this.getConfigItem(duration);
                if (configItem) {
                    this.count({
                        statKey: 'long_time_task_count',
                        statSubKey: this.pageName + '_' + configItem.name,
                        value: 1,
                        valueType: 4,
                    }).then();
                }
                const { statKey, statSubKey } = this.getKeyByDuration();
                if (statKey && duration > 50) {
                    const needSendToServer = Math.random() > 0.9;
                    if (!needSendToServer) {
                        continue;
                    }
                    items.push(pointItem({
                        statKey,
                        statSubKey,
                        params: { startTime, uptime: window.process ? window.process.uptime() : -1 },
                        value: duration,
                        valueType: 2,
                    }));
                    let segmentSubKey = '';
                    if (duration < 80) {
                        segmentSubKey = 'lowest_duration';
                    }
                    else if (duration >= 80 && duration < 150) {
                        segmentSubKey = 'normal_duration';
                    }
                    else if (duration >= 150) {
                        segmentSubKey = 'highest_duration';
                    }
                    items.push(pointItem({
                        statKey,
                        statSubKey: segmentSubKey,
                        value: duration,
                        valueType: 2,
                        params: {
                            startTime,
                            uptime: window.process ? window.process.uptime() : -1,
                        },
                    }));
                }
            }
            this.point(items).then();
        });
        observer.observe({ entryTypes: ['longtask'] });
        this.longTaskObserving = true;
    }
    async handleRemainLog() {
        let addLogs = [];
        try {
            if (isElectron() && window.electronLib) {
                const data = await window.electronLib.storeManage.get('performanceLog', 'noReportLog');
                if (data && typeof data === 'string' && data.length > 0)
                    addLogs = JSON.parse(data);
            }
            else {
                const dt = await this.storeApi.get('performanceLog-noReportLog', { noneUserRelated: true });
                if (dt && dt.suc && dt.data) {
                    addLogs = JSON.parse(dt.data);
                }
            }
        }
        catch (ex) {
            console.warn('[performance] remain log handle', ex);
        }
        if (addLogs && addLogs.length) {
            this.doUploadLogs(addLogs);
            this.saveLog([]).then();
        }
    }
    sendProcessCpuInfos(processMetricList) {
        const processTypeWhiteListMap = { Browser: true, GPU: true, Utility: true };
        const processTypeKeyMap = {
            Browser: 'main_process_cpu_used',
        };
        const processTypeCPULimitMap = {
            Browser: 700,
        };
        const pointList = [];
        processMetricList.forEach(processMetric => {
            const processType = processMetric.type;
            if (processTypeWhiteListMap[processType]) {
                const performanceKey = processTypeKeyMap[processType];
                const percentCPUUsage = processMetric.cpu ? processMetric.cpu.percentCPUUsage : null;
                if (!percentCPUUsage) {
                    return;
                }
                const statSubKey = processMetric.name ? processMetric.name + '_' + (processMetric.serviceName || '') : '';
                const percentCPUUsageNum = Number.parseFloat(Number(percentCPUUsage).toFixed(3));
                const minNum = processTypeCPULimitMap[processType];
                if (minNum) {
                    if (percentCPUUsageNum && percentCPUUsageNum < minNum) {
                        return;
                    }
                }
                pointList.push({
                    statKey: performanceKey,
                    statSubKey,
                    value: percentCPUUsageNum,
                    valueType: 2,
                });
            }
        });
        if (pointList && pointList.length) {
            this.point(pointList).catch(err => {
                console.error('sendProcessCpuInfos error', err);
            });
        }
    }
    sendRenderProcessCount(processMetricList) {
        const renderProcessType = 'Tab';
        const count = processMetricList.filter(processMetric => processMetric.type === renderProcessType).length;
        if (!count || count < 10) {
            return;
        }
        this.point({
            statKey: 'render_process_count',
            value: count,
            valueType: 2,
        }).catch(err => {
            console.error('sendRenderProcessCount error', err);
        });
    }
    getWindowsProcessMemoryInfos(processMetricList) {
        const processTypeWhiteListMap = { Browser: true, GPU: true, Utility: true };
        const result = [];
        processMetricList.forEach(processMetric => {
            const processType = processMetric.type;
            if (!processTypeWhiteListMap[processType]) {
                return;
            }
            const privateBytes = processMetric.memory.privateBytes;
            const privateMb = Number.parseFloat((privateBytes / 1024).toFixed(2));
            result.push({
                type: processType,
                memoryUsed: privateMb,
                name: processMetric.name,
                serviceName: processMetric.serviceName,
            });
        });
        return result;
    }
    sendTotalMemoryInfo(processMetricList) {
        if (!processMetricList)
            return;
        let sum = 0;
        processMetricList.forEach(processMetric => {
            const processMemoryUsed = processMetric.memory.privateBytes;
            if (processMemoryUsed) {
                sum += processMemoryUsed;
            }
        });
        if (!sum) {
            return;
        }
        const totalMemoryUsed = Number.parseFloat((sum / 1024).toFixed(2));
        if (totalMemoryUsed < 2560) {
            return;
        }
        this.point({
            statKey: 'total_process_memory_used',
            valueType: 2,
            value: totalMemoryUsed,
        }).catch(err => {
            console.error('sendTotalMemoryInfo Error', err);
        });
    }
    sendProcessMemoryInfos(processMetricList) {
        const processMemoryInfos = this.getWindowsProcessMemoryInfos(processMetricList);
        const processTypeKeyMap = {
            Browser: 'main_process_memory_used',
            GPU: 'gpu_process_memory_used',
        };
        const processTypeKeyLimitMap = {
            Browser: 400,
            GPU: 500,
        };
        const pointList = [];
        processMemoryInfos.forEach(processMemoryInfo => {
            if (!processMemoryInfo.memoryUsed)
                return;
            const processType = processMemoryInfo.type;
            const limitNum = processTypeKeyLimitMap[processType];
            if (limitNum) {
                const memoryUsedNum = processMemoryInfo.memoryUsed;
                if (memoryUsedNum && memoryUsedNum < limitNum) {
                    return;
                }
            }
            const performanceKey = processTypeKeyMap[processType];
            if (!performanceKey)
                return;
            const statSubKey = processMemoryInfo.name ? processMemoryInfo.name + '_' + (processMemoryInfo.serviceName || '') : '';
            pointList.push({
                statKey: performanceKey,
                statSubKey,
                valueType: 2,
                value: processMemoryInfo.memoryUsed,
            });
        });
        if (pointList && pointList.length) {
            this.point(pointList).catch(err => {
                console.error('sendProcessMemoryInfos error', err);
            });
        }
    }
    async sendProcessMemoryAndCpuInfos() {
        if (process.env.BUILD_ISWEB || process.env.BUILD_ISEDM) {
            return;
        }
        if (!this.systemApi.isMainPage()) {
            return;
        }
        const processMetricList = await window.electronLib.appManage.getAppMetrics();
        if (!processMetricList || !processMetricList.length) {
            return;
        }
        this.sendProcessCpuInfos(processMetricList);
        this.sendRenderProcessCount(processMetricList);
        this.sendProcessMemoryInfos(processMetricList);
        this.sendTotalMemoryInfo(processMetricList);
    }
}
const performanceImpl = new PerformanceImpl();
api.registerLogicalApi(performanceImpl);
export default performanceImpl;
